/**
 * Normalize image URL to be relative to current domain.
 * Handles cases where database contains absolute URLs from other domains.
 * Company logos are stored as filenames and served at root level (e.g., /logo.jpg)
 *
 * Examples:
 *   https://app.valueit.io/logo.jpg -> /logo.jpg
 *   https://prod.valueit.io/logo.jpg -> /logo.jpg
 *   /logo.jpg -> /logo.jpg
 *   logo.jpg -> /logo.jpg
 */
export const normalizeImageUrl = (url: string | undefined | null): string => {
  if (!url) return "";

  // If already a data URL, return as-is
  if (url.startsWith("data:")) {
    return url;
  }

  // List of known domains to strip
  const knownDomains = [
    "https://app.valueit.io",
    "https://prod.valueit.io",
    "https://dev.valueit.io",
    "https://valueit.lk",
    "https://www.valueit.lk",
    "http://app.valueit.io",
    "http://localhost:3000",
    "http://localhost:3001",
  ];

  let normalized = url;

  // Strip known domains to make URL relative
  for (const domain of knownDomains) {
    if (normalized.startsWith(domain)) {
      normalized = normalized.replace(domain, "");
      break;
    }
  }

  // Also handle any https://*.valueit.io or https://*.valueit.lk pattern
  normalized = normalized.replace(/^https?:\/\/[^/]*\.?valueit\.(io|lk)/, "");

  // Ensure URL starts with /
  if (
    normalized &&
    !normalized.startsWith("/") &&
    !normalized.startsWith("data:")
  ) {
    normalized = "/" + normalized;
  }

  return normalized;
};

/**
 * Get full image URL for current domain
 */
export const getImageUrl = (path: string | undefined | null): string => {
  return normalizeImageUrl(path);
};
